export default __webpack_public_path__ + "static/media/infoIcon.759782e8.svg";